import Vue from 'vue';
export default Vue.component('ed-h1', { name: 'ed-h1'});